<div>
  <div>
    <div style="border-right: 0px; border-left: 0px; border-bottom: 0px">
      <div class="list-group" style="cursor: pointer; color: #0063b9">
        <a class="list-group-item list-group-item-action">
          <div class="col-sm-12" style="padding: 0px 5px !important">
            <i
              class="fas fa-store"
              style="margin-right: 5px; color: #0063b9"
            ></i>
            {{ selectedStore?.address }}
          </div>
          @if (productDropshipment === 0) {
          <hr style="margin: 1px 0px; padding: 1px" />
          } @if (productDropshipment === 0) {
          <div
            class="col-sm-12 text-red-500"
            style="padding: 5px 5px !important"
          >
            {{ stock }} UNIDADES Disponibles
          </div>
          } @if (stock === 0) {
          <div
            class="col-sm-12 text-red-500"
            style="
              text-align: justify;
              padding: 5px 5px !important;
              font-style: italic;
              font-size: 9px;
            "
          >
            *Las fechas indicadas en la parte inferior indican cuando podrían
            haber unidades para su retiro.
          </div>
          }
        </a>
      </div>
      <div
        style="
          color: #00549d;
          text-align: justify;
          padding: 14px 5px !important;
          font-size: 13px;
          letter-spacing: 0px;
        "
      >
        En caso de necesitar más unidades, puedes simular las fechas de retiro
        en el tipo de entrega previo a finalizar tu compra.
      </div>
    </div>
  </div>
  <div>
    <div style="border: 1px solid #00549d">
      @if (isMapLoaded) {
      <google-map
        height="300px"
        width="100%"
        [options]="options"
        [center]="center"
        [zoom]="zoom"
      >
        @for (position of markerPositions; track position) {
        <map-marker [position]="position" [options]="markerOptions" />
        }
      </google-map>
      }
    </div>
  </div>
</div>
